// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YMkyR","container_video":"styles_container_video__7Kmho","video":"styles_video__rGx54","content":"styles_content__lWzpd","button":"styles_button__-2NOA"};